import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export type InutilizacaoTableType = {
  id: number;
  serie: number;
  tipoDocumento: number; // Enum value: 55 (NFe) or 65 (NFCe)
  inicio: number;
  fim: number;
  justificativa: string;
  empresaId: number;
  empresaNome: string;
  usuarioId: number;
  usuarioNome: string;
  createdAt: string;
  updatedAt: string;
};

export type InutilizacaoFilterType = {
  pageIndex: number;
  pageSize: number;
  serie?: number;
  tipoDocumento?: number;
};

export type TipoDocumentoType = {
  id: number;
  descricao: string;
};

export const tiposDocumento: TipoDocumentoType[] = [
  { id: 55, descricao: "NFe - Nota Fiscal Eletrônica" },
  { id: 65, descricao: "NFCe - Nota Fiscal de Consumidor Eletrônica" },
];

export const inutilizacoesBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Operacional",
    url: "#!",
  },
  {
    label: "Inutilizações",
    active: true,
  },
];

export const novaInutilizacaoBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Operacional",
    url: "#!",
  },
  {
    label: "Inutilizações",
    url: "/operacional/inutilizacao",
  },
  {
    label: "Nova Inutilização",
    active: true,
  },
]; 